<script setup>
import { DEV_MODE } from '@/config/dev-mode';
import axios from 'axios';
import fiveMixin from '@/composables/fiveMixin';
import FiveStarAppComponent from '@/components/saju/FiveStarAppComponent.vue';
import '@/assets/nangman_style/popup/five_element_diagram_mobile.scss';
import { addContentLogAPI } from '@/api/logServiceApi';
import { useLogsStore } from '@/store/modules/logsStore';

definePage({ meta: { layout: 'empty' } });

const logsStore = useLogsStore();

const route = useRoute()

const { ...five } = fiveMixin();

const paramData = ref({
  year: '',
  month: '',
  day: '',
  hour: '',
  min: '',
  gender: null,
  userName: '',
  isLunar: false,
  lunar: null,
  isLeapYear: null,
  bornAreaId: null,
  birth_time: null,
  birth: null,
  birthTime: null,
  unknownTime: null,
  option1: true,
  option2: true,
  option3: false,
  option4: true,
  addressTxt: null,
  lang: 'KOR',
  langYN: 'N',
  userGroupId: null,
  shortly: false,
  blCheck: 'N',
});
const sajuData = ref({});
const inputdata = ref({});
const transdata = ref({});
const birthData = ref({});
const birthEightTxt = ref('');
const daeunsData = ref({});

const langMode = ref('CHNKOR');

/** 페이지 크기조절 */
const manseAppStyle = ref({});
/** 오행도 크기조절 */
const fiveStarStyle = ref({});

const isPageLoading = ref(true);

const accessToken = ref(null);
const authUserId = ref(null);
const guestUserId = ref(null);
const isMySaju = ref(false);
const availableHeight = ref(null);
const webviewPadding = 0;

const error = ref(null);

onMounted(async () => {
  sendMessage('onMounted');
  // const vAppWrap = document.querySelector('.v-application__wrap');
  // if (vAppWrap) vAppWrap.classList.add('custom-wrap-style');
  updateScale();
  document.addEventListener('resize', updateScale);
  document.addEventListener('message', handleMessage);
  window.addEventListener('resize', updateScale);
  window.addEventListener('message', handleMessage);
  
  isPageLoading.value = false;
});

onUnmounted(() => {
  // const vAppWrap = document.querySelector('.v-application__wrap');
  // if (vAppWrap) vAppWrap.classList.remove('custom-wrap-style');
  document.removeEventListener('resize', updateScale);
  document.removeEventListener('message', handleMessage);
  window.removeEventListener('resize', updateScale);
  window.removeEventListener('message', handleMessage);
});

watch(guestUserId, async (newValue) => {
  if (newValue) {
    await getSajuParams(newValue);
    await getManseForce(newValue);
  }
});

/** 화면 크기에 맞춰 컴포넌트 크기 조정 */
const BASE_WIDTH = 500;
const BASE_HEIGHT = 600;

const updateScale = () => {
  const widthScale = window.innerWidth < BASE_WIDTH ? (window.innerWidth - webviewPadding * 2) / BASE_WIDTH : 1;
  const heightScale = availableHeight.value ? availableHeight.value / BASE_HEIGHT : 1;
  const scale = Math.min(widthScale, heightScale);
  const height = BASE_HEIGHT * scale;

  fiveStarStyle.value = {
    transform: `scale(${scale})`,
    transformOrigin: 'center',
    width: `${BASE_WIDTH}px`,
    minWidth: `${BASE_WIDTH}px`,
    borderRadius: `${webviewPadding}px`,
  };

  manseAppStyle.value = {
    height: `${height}px`,
    borderRadius: `${webviewPadding}px`,
  };
};
const pageMode = ref('rs');
const handleMessage = async (event) => {
  sendMessage('handleMessage');
  try {
    let data;

    if (typeof event.data === 'string') {
      data = JSON.parse(event.data);
    } else {
      data = event.data;
    }

    // React DevTools 메시지 무시
    if (data.source === 'react-devtools-content-script') {
      return;
    }

    if (data) {
      // guestUserId.value = data.guestUserId;
      accessToken.value = data.accessToken;
      // authUserId.value = data.authUserId;

      // RN에서 전달받은 가용 높이로 스케일 재계산
      if (data.availableHeight) {
        availableHeight.value = data.availableHeight;
        updateScale();
      }

      if (route.params.id) guestUserId.value = route.params.id;
      else if (data.birthData) {
        birthData.value = data.birthData;
        extractBirthEightTxt(data.birthData);
      }

      if (accessToken.value) {
        axios.defaults.headers.common['Authorization'] = accessToken.value;
        axios.defaults.headers.common['authUserId'] = userId.value;
      }
    }
  } catch (e) {
    sendError(e);
    console.error('Invalid message received:', `${e}`);
  }
};

const getDetailAPI = async (id) => {
  let url = `/users/groupGuestUsers/${id}`;
  axios.defaults.headers.common['Authorization'] = accessToken.value;
  const response = await axios.get(url);
  return response.data;
};

const getSajuParams = async (id) => {
  if (!id) return;

  try {
    const result = await getDetailAPI(id);
    isMySaju.value = result?.isMySaju === true;
    paramData.value.userName = result?.guestUserName || '';
    if (!isMySaju.value) {
      convertManseForceParams(result);
    }
  } catch (e) {
    sendError(e);
    DEV_MODE && console.error('사주정보 조회 오류:', e);
  };
};

const padNumber = (num) => num.toString().padStart(2, '0');
const convertManseForceParams = (result) => {
  const dateTime = result.integrationBirth.split('T');
  const [year, month, day] = dateTime[0].split('-');
  const [hour, min] = dateTime[1]?.split(':');
  
  paramData.value.year = year;
  paramData.value.month = month.padStart(2, '0');
  paramData.value.day = day.padStart(2, '0');
  paramData.value.hour = hour.padStart(2, '0');
  paramData.value.min = min.padStart(2, '0');
  paramData.value.gender = result.gender === 'MEN' ? 1 : 0;
  paramData.value.userName = result.guestUserName;
  paramData.value.isLunar = result.isLuna === null ? false : result.isLuna;
  paramData.value.lunar = result.lunar;
  paramData.value.isLeapYear = result.isLeapYear;
  paramData.value.bornAreaId = result.bornAreaId;
  paramData.value.unknownTime = result.unknownTime
  paramData.value.option1 = result.option1;
  paramData.value.option2 = result.option2;
  paramData.value.option3 = result.option3;
  paramData.value.option4 = result.option4;
  paramData.value.option5 = result.option5;
  paramData.value.addressTxt = result.bornArea;
  paramData.value.birth = `${year}-${padNumber(month)}-${padNumber(day)}`
  // paramData.value.lang = result.lang
  // paramData.value.langYN = result.langYN
  // paramData.value.userGroupId = result.userGroupId
  
  if (result.birthTime === '25:00') {
    paramData.value.birthTime = result.birthTime;
    paramData.value.unknownTime = 'Y';
  } else {
    paramData.value.birthTime = `${padNumber(hour)}:${padNumber(min)}`;
    paramData.value.unknownTime = 'N';
  }
  if (!paramData.value.isLeapYear) paramData.value.isLeapYear = false;
  if (paramData.value.bornAreaId === null) delete paramData.value.bornAreaId;
}

const extractBirthEightTxt = (birthData) => {
  const skyValues = [
    five.getHanjaTxt(birthData.sky.year.value, 'sky'),
    five.getHanjaTxt(birthData.sky.month.value, 'sky'),
    five.getHanjaTxt(birthData.sky.day.value, 'sky'),
    birthData.sky.hour?.value !== '-'
      ? five.getHanjaTxt(birthData.sky.hour.value, 'sky')
      : '-',
  ];
  const earthValues = [
    five.getHanjaTxt(birthData.earth.year.value, 'earth'),
    five.getHanjaTxt(birthData.earth.month.value, 'earth'),
    five.getHanjaTxt(birthData.earth.day.value, 'earth'),
    birthData.earth.hour?.value !== '-'
      ? five.getHanjaTxt(birthData.earth.hour.value, 'earth')
      : '-',
  ];

  birthEightTxt.value = skyValues.join('') + earthValues.join('');  
};

const fastSearchAPI = async (params) => {
  axios.defaults.headers.common['Authorization'] = accessToken.value;
  let url = `/fast/manseForce/`;
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([key, value]) => value != null),
  )

  const response = await axios.get(url, {params: filteredParams});

  return response.data;
};

const getManseForce = async (id) => {
  if (!id) return;

  try {
    const requestParams = isMySaju.value
      ? { guestUserId: Number(id), userName: paramData.value.userName }
      : paramData.value;
    const result = await fastSearchAPI(requestParams);
    sajuData.value = result;
    inputdata.value = result.inputdata;
    transdata.value = result.transdata;
    birthData.value = result.birthganji;
    daeunsData.value = result.daeuns;
    extractBirthEightTxt(result.birthganji);
  } catch (e) {
    sendError(e);
    DEV_MODE && console.error('만세력 조회 오류:', e);
  }
};

/** 일간 특성 */
const openIlgan = (type) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "openIlgan" }));
  }

  let contentType = 'sl_';
  if (!guestUserId.value) contentType = 'manse_';
  if (type === '일간') contentType += 'btn_click_ilgan_opt3';
  else contentType += 'btn_click_ilgan_feature_opt3';

  const args = {
    contentType,
    option3: '일반',
  }
  addContentLogAPI(args);
}

const openFive = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "openFive" }));
  }

  const args = {
    contentType: guestUserId.value ? 'sl_btn_click_ohangdo_opt3' : 'manse_btn_click_ohangdo_opt3',
    option3: '일반'
  }
  addContentLogAPI(args);
}

const sendMessage = (message) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "sendMessage", message }));
  }
}

const sendError = (error) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "sendError", error }));
  }
}
</script>

<template>
  <div class="manse-app" :style="manseAppStyle">
    <button class="five-ilgan-button" @click="openIlgan" v-if="rootPage !== 'analysis'">
    일간 특성<i class="five-ilgan-icon"></i>
    </button>
    <div class="five-star" :style="fiveStarStyle">
      <FiveStarAppComponent
        :birthData="birthData"
        :birthEightTxt="birthEightTxt"
        @openIlgan="openIlgan"
        @openFive="openFive"
        @sendError="sendError"
      />
    </div>
    <button
      class="five-tooltip-button"
      @click="openFive"
      v-if="rootPage !== 'analysis'"
    >
      <div class="orange">낭만만세력</div>
      오행도<i class="five-tooltip-icon"></i>
    </button>
  </div>
</template>

<style>
.custom-wrap-style {
  min-height: fit-content !important;
}
</style>